module.exports = __webpack_public_path__ + "img/cn.f80957c7.svg";